(function () {
  'use strict';
  var pending = false;
  function initialize() {
    document.querySelectorAll('[data-hgb-pairs]').forEach(function (section) {
      if (section.dataset.hgbReady) return;
      section.dataset.hgbReady = 'true';
      section.querySelectorAll('[data-hgb-pair-button]').forEach(function (button) {
        button.hidden = false;
        button.dataset.originalText = button.textContent;
        button.addEventListener('click', async function () {
          if (pending) return;
          pending = true;
          var buttons = document.querySelectorAll('[data-hgb-pair-button]');
          buttons.forEach(function (item) { item.disabled = true; });
          button.textContent = button.dataset.busyText;
          var error = section.querySelector('[data-hgb-pair-error]');
          error.hidden = true;
          try {
            var cartResponse = await fetch(section.dataset.cartUrl + '.js', {credentials:'same-origin', cache:'no-store'});
            if (!cartResponse.ok) throw new Error('cart_read');
            var cart = await cartResponse.json();
            if (!Array.isArray(cart.items)) throw new Error('cart_shape');
            var ids = [Number(button.dataset.mainId), Number(button.dataset.companionId)];
            var items = ids.filter(function (id) {
              if (!Number.isSafeInteger(id) || id <= 0) throw new Error('variant');
              return !cart.items.some(function (item) { return Number(item.variant_id) === id && item.quantity > 0; });
            }).map(function (id) { return {id:id, quantity:1}; });
            if (items.length) {
              var response = await fetch(section.dataset.addUrl, {
                method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:items})
              });
              if (!response.ok) throw new Error('cart_add');
              await response.json();
            }
            window.location.assign(section.dataset.cartUrl);
          } catch (failure) {
            error.hidden = false;
            pending = false;
            buttons.forEach(function (item) { item.disabled = false; item.textContent = item.dataset.originalText; });
          }
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('pageshow', function () {
    pending = false;
    document.querySelectorAll('[data-hgb-pair-button]').forEach(function (button) {
      button.disabled = false;
      if (button.dataset.originalText) button.textContent = button.dataset.originalText;
    });
  });
}());
